import { createSlice } from "@reduxjs/toolkit";
import {
  reducers,
  extraReducers,
  initialState,
} from "./reducers/schoolReducers";

export const SchoolSlice = createSlice({
  name: "school",
  initialState,
  reducers,
  extraReducers,
});

export const {
  setSchoolCode,
  setAutofillSchoolCode,
  clearAutofillSchoolCode,
  expireJustLoaded,
  resetSchoolLoadingState,
  setOwnershipTransfer,
} = SchoolSlice.actions;

export default SchoolSlice.reducer;
